module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-ru.1ae2a83a295d97b6c004.svg";